import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP } from "./reducers/audit-properties-reducer";
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";

export const toggleAuditGroupProcessWarningPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP,
    data: {
      isAuditGroupProcessWarningPopupVisible: isVisible
    },
  });
}


const AuditGroupProcessWarningPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const eaProcessTemplateId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData.eaProcessTemplateId,
    isEqual
  );

  const processesTemplatesList = useSelector(
    (state) => state["auditPropertiesReducer"].processesTemplatesList,
    isEqual
  );

  const getProcessName = () => {
    if (eaProcessTemplateId) {
      let filteredItem = processesTemplatesList?.filter(x => x.eaProcessTemplateId === eaProcessTemplateId)
      return filteredItem && filteredItem[0]?.name;
    }
  }

  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          props.onAuditGroupProcessWarningCancelClick();
          toggleAuditGroupProcessWarningPopup(false, dispatch);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={400}
        height={200}
        className="-warning-popup"
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP,
            reducerName: "auditPropertiesReducer",
            widgetOptionBindings: {
              visible: "isAuditGroupProcessWarningPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div className="message-section">
                  The current process is not linked to the new Audit Group. All tasks linked to the process  {getProcessName()}  will be deleted. Do you want to continue?
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    props.onAuditGroupProcessWarningCancelClick();
                    toggleAuditGroupProcessWarningPopup(false, dispatch);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    props.onAuditGroupProcessWarningOkClick();
                    toggleAuditGroupProcessWarningPopup(false, dispatch);
                  }}
                >
                  Ok
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default AuditGroupProcessWarningPopup;